<template>
  <span :title="row[col.field]">{{row[col.field]}}</span>
</template>

<script>
export default {
  name: 'TemplateString',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
